import React, { useState, createContext, useContext, ReactNode, FormEvent } from 'react'
import PropTypes from 'prop-types'

interface ControlContextProps {
	data: any,
	changeControl: unknown,
	changeTemplate: unknown,
	saveToCollection: any,
	copyItem: any,
}

interface ControlProviderProps {
	children: ReactNode,
}

interface InitialStateProps {
	control: string,
	template: string,
	collection: string[],
}

export const ControlContext = createContext<Partial<ControlContextProps>>({})

export const ControlProvider = ({ children }: ControlProviderProps) => {
	const [state, setState] = useState<InitialStateProps>({
		control: 'company',
		template: 'template1',
		collection: [],
	})
	return (
		<ControlContext.Provider
			value={{
				data: state!,
				changeControl: (e: FormEvent<HTMLInputElement>) => {
					setState({
						...state,
						control: e.currentTarget.value
					})
				},
				changeTemplate: (e: FormEvent<HTMLInputElement>) => {
					setState({
						...state,
						template: e.currentTarget.value
					})
				},
				saveToCollection: (collectionItem: any) => {
					setState({
						...state,
						collection: [...state.collection, collectionItem.innerHTML],
					})
				},
			}}
		>
			{children}
		</ControlContext.Provider>
	)
}

export const useControlValue = () => useContext<Partial<ControlContextProps>>(ControlContext)

ControlProvider.propTypes = {
	children: PropTypes.node,
}
